import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    // AuthGuard on dashboard will redirect unauthenticated users to sign-in.
    // Authenticated users (returning with a valid cookie) go straight to dashboard.
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Public routes (no auth, no Fuse layout chrome)
    { path: 'register/:token', loadChildren: () => import('app/modules/public/registration/public-registration.routes') },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
            // { path: 'CampRegister', loadChildren: () => import('app/layout/common/camp-register/CampRegister.routes') }
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes') },
            { path: 'profile', loadChildren: () => import('app/modules/admin/profile/profile.routes') },
            { path: 'camps', loadChildren: () => import('app/modules/admin/camp/camp.routes') },
            { path: 'camp-category', loadChildren: () => import('app/modules/admin/camp-category/camp-category.routes') },
            { path: 'trains', loadChildren: () => import('app/modules/admin/trains/trains.routes') },
            { path: 'additional-fees', loadChildren: () => import('app/modules/admin/additional-fees/additional-fees.routes') },
            { path: 'organizations', loadChildren: () => import('app/modules/admin/organization/organization.routes') },
            { path: 'users', loadChildren: () => import('app/modules/admin/users/users.routes') },
            { path: 'participants', loadChildren: () => import('app/modules/admin/participants/participants.routes') },
            { path: 'countries', loadChildren: () => import('app/modules/admin/locations/country/country.routes') },
            { path: 'trains', loadChildren: () => import('app/modules/admin/trains/trains.routes') },
            { path: 'inventory', loadChildren: () => import('app/modules/admin/inventory/inventory.routes') },
            { path: 'chat', loadChildren: () => import('app/modules/admin/apps/chat/chat.routes') },
            { path: 'camp-registrations', loadChildren: () => import('app/modules/admin/camp-registration/camp-registration.routes') }
        ]
    }
];
